import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { SectorsAirCouponListComponent } from './sector-air-coupon-list.component';
import { StatusPannelModule } from '../status-pannel/status-pannel.module';

@NgModule({
    imports: [
        CommonModule,
        StatusPannelModule,
    ],
    exports: [SectorsAirCouponListComponent],
    declarations: [SectorsAirCouponListComponent],

})
export class SectorsAirCouponListModule {}

